export const css = {
	root: '_2IjykYbk',
	' _key': 'certwise-theme/dojo/grid-footer'
};

export default css;
